export const ALL_COMPARATORS = {
  is: 'is',
  is_not: 'is_not',
  less_than_or_equal_to: 'less_than_or_equal_to',
  greater_than_or_equal_to: 'greater_than_or_equal_to',
  between: 'between',
  is_not_defined: 'is_not_defined',
  is_defined: 'is_defined',
  contain: 'contain',
  does_not_contain: 'does_not_contain',
  contains_data: 'contains_data',
  does_not_contain_data: 'does_not_contain_data',
  starts_with: 'starts_with',
  ends_with: 'ends_with',
  is_true: 'is_true',
  is_false: 'is_false',

  before: 'before',
  after: 'after',

  // todo: Not added currently, add as per requirement
  changed_to: 'changed_to',
  changed_from_to: 'changed_from_to',

  // Time Options
  yesterday: 'yesterday',
  today: 'today',
  tomorrow: 'tomorrow',
  last_week: 'last_week',
  this_week: 'this_week',
  next_week: 'next_week',
  last_month: 'last_month',
  this_month: 'this_month',
  next_month: 'next_month',
  last_n_days: 'last_n_days',
  next_n_days: 'next_n_days',
  last_n_hours: 'last_n_hours',
  custom: 'custom',
  all_time: 'all_time',
} as const;

export const CUSTOM_TIME_COMPARATORS: string[] = [
  ALL_COMPARATORS.last_n_days,
  ALL_COMPARATORS.next_n_days,
  ALL_COMPARATORS.last_n_hours,
  ALL_COMPARATORS.custom,
] as const;

export const COMPARATORS_WITHOUT_VALUE: string[] = [
  ALL_COMPARATORS.is_defined,
  ALL_COMPARATORS.is_not_defined,
  ALL_COMPARATORS.is_true,
  ALL_COMPARATORS.is_false,
  ALL_COMPARATORS.contains_data,
  ALL_COMPARATORS.does_not_contain_data,
] as const;

export type ComparatorType = (typeof ALL_COMPARATORS)[keyof typeof ALL_COMPARATORS];
